<template>
    <div id="index" class="animate-in">
        <!--顶部搜索筛选-->
        <div class="row">
            <div class="col-md-12">
                <div class="box fz-content-box">
                    <div class="box-body fz-box-body">
                    
                        <form class="form-inline searchForm" id="searchForm" action="#" method="GET">
                            <div class="form-group mr15"><span class="fz-menu-name">服务网点</span></div>

                            <div class="form-group">
                                <a href="#" class="btn btn-xs btn-warning ml15 nocss-adddevice fz-color-black" @click="addProduct">＋添加</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!--数据列表页面-->
        <section class="content">
            <div class="row">
                <div class="col-md-12">
                    <div class="box fz-box">
                        <div class=" table-responsive">
                            <table class="table table-hover fz-table-hover fz-table-bordered datatable" width="100%">
                                <thead>
                                <tr class="fz-gray">
                                    <th style="width:60px;">ID</th>
                                    <th style="width:180px;">网点名称</th>
                                    <th style="width:160px;">电话</th>
                                    <th>地址</th>
                                    <th style="width:80px;">编辑</th>
                                   
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in currentList" :key="item.key" :class="[index===1?'active':'']">
                                    <td>{{item.id}}</td>
                                    <td>{{item.title}}</td>
                                    <td>{{item.tel}}</td>
                                    <td>{{item.address}}</td>
                                               
                                    <td class="td-do">
                                        <a class="fz-edit-primary mr10" title="修改" data-toggle="tooltip"  @click="editProduct(item)">
                                            <i class="fa fa-pencil"></i>
                                        </a>
                                        <a class="fz-delete ajaxButton" title="删除" @click="deleteProduct(item)">
                                            <i class="fa fa-times" aria-hidden="true"></i>
                                        </a>
                                    </td>
                                  
                                </tr>
                                
                                </tbody>
                            </table>
                        </div>

                    </div>
                    
                </div>
            </div>
        </section>

        <!--添加编辑产品 -->
        <transition name="el-fade-in">
            <v-drag v-if="isShow" :title="title" :hiddenCancel="hiddenCancel"
             @confirm="confirmSubmit" @cancel="cancel" :buttonstatus="buttonstatus" :widthData="'500px'" :confirmtext="confirmtext">
                <div class="modal-body">
                     <loading :active.sync="isLoading" 
                    :can-cancel="false" 
                    :background-color="'#fff'" 
                    :height="60"
                    :opacity="0.7"
                    :width="60"
                    :is-full-page="false"></loading>
                    <form method="post" class="form-horizontal">
                         <div class="form-group">
                            <label class="col-xs-2 control-label fz-form-label">网点名称:</label>
                            <div class="col-xs-8">
                                <input type="text" id="move_tuihuonum" class="form-control fz-form-input"
                                 v-model="edtiInfo.title" style="height: 25px;line-height: 25px;">
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-xs-2 control-label fz-form-label">电话:</label>
                            <div class="col-xs-8">
                                <input type="text" id="move_tuihuonum" class="form-control fz-form-input"
                                 v-model="edtiInfo.tel" style="height: 25px;line-height: 25px;">
                            </div>
                        </div>

                         <div class="form-group">
                                <label class="col-xs-2 control-label fz-form-label">经纬度</label>
                                <div class="col-sm-8">
                                    <input type="text" v-model="edtiInfo.lat" class="form-control fz-form-input" >
                                     <p style="padding:10px 5px;">
                                    查询工具地址：<a target="_blank" href="https://api.map.baidu.com/lbsapi/getpoint/index.html">https://api.map.baidu.com/lbsapi/getpoint/</a>
                                </p>
                                </div>
                               

                        </div>

                        <div class="form-group">
                            <label class="col-xs-2 control-label fz-form-label">地址:</label>
                            <div class="col-xs-8">
                                <input type="text" id="move_tuihuonum" class="form-control fz-form-input"
                                 v-model="edtiInfo.address" style="height: 25px;line-height: 25px;">
                            </div>
                        </div>

                    </form>
                </div>
            </v-drag>
        </transition>

        <!--删除产品 -->
        <transition name="el-fade-in">
            <v-drag v-if="isShowDelete" @confirm="deleteSubmit" @cancel="deleteCancel"  :widthData="'350px'">
                <div class="delete-modal">
                    <div class="delete-content">
                        <img src="../../static/images/what.png" alt="删除">
                        确定要删除此项目？删除后不可恢复
                    </div>
                </div>
            </v-drag>
        </transition>

    </div>
</template>

<script>
import pagination from "@/components/pagination.vue"
import vDrag from "@/components/dragDiv.vue"
import glob from '@/utils/global.js'
import {req} from "../../api/axiosFun" 
  import moment from 'moment'
import Loading from 'vue-loading-overlay';
export default {
    name: 'productlist',
    data() {
        return {
            loading: false, //是显示加载
            isLoading:false,
            content: "",
            listData: [],
            imgPath: "",  // 上传图片url
            accept: 'image/jpeg,image/png,image/x-icon',
            currentList: [],
            // 分页参数
            num: 0,
            limit: 2,
            pageparm: {
                currentPage: 1,
                pageSize: 2,
                total: 9
            },
            isEdit: false, //是否编辑状态
            isShow: false, //是否显示添加编辑弹出框
            title: "编辑产品",
            hiddenCancel: true,
            buttonstatus: 0,
            confirmtext: "保存",
            edtiInfo: {
                id: 0,
                type1: -1,
                type2: -1,
                name: "",
                filepath: "",
                content: "",
                product_model: "",
                bjl: "",
                gzwd: "",
                ctrl: "",
                area: "",
                product_info: ""
            },
            isShowDelete: false, //删除弹框
        }
    },
    components: {
        pagination,Loading,
        vDrag
    },
    mounted() {
        this.requestData();
        this.$parent.isLoading  = true;
    },
    methods: {
        async saveProduct()
        {
            this.isLoading = true;
            this.edtiInfo.img_path = this.imgPath;
            if(this.edtiInfo.id) {
                let res = await this.$api.request('PUT', '/service/' + this.edtiInfo.id, this.edtiInfo)
                if(res.res=='err') {
                    this.$toast.open({
                            message:'修改失败!',
                            type:'warning',
                            position:'top'
                        });
                } else {
                    this.$toast.open({
                        message:'修改成功!',
                        type:'success',
                        position:'top'
                        
                    });;
                }
                this.isShow = false;
                this.requestData();
            } else {
                let res = await this.$api.request('POST', '/service', this.edtiInfo)
                if(res.res=='err') {
                    this.$toast.open({
                         message:'保存失败!',
                         type:'warning',
                         position:'top'
                         
                     });
                } else {
                     this.$toast.open({
                         message:'保存成功!',
                         type:'success',
                         position:'top'
                         
                     });
                 }
                this.requestData();
                this.isShow = false;
            }
             this.isLoading = false;
             
        },
        updateData(e) {
            console.log(e)
            this.edtiInfo.content = e;
        },
        addProduct() {
            this.title = '添加产品';
            this.edtiInfo={}
            this.isShow = true;
        },
        editProduct(item) {
            this.edtiInfo = item;
            this.imgPath = item.img_path;
            this.isShow = true;
            this.isEdit = true;
            this.title = '修改产品';
        },
        async requestData() {
            try {
                const res = await this.$api.get('/service');
                this.listData = res.data;
                this.currentList = res.data;
                this.$parent.isLoading  = false;
            } catch(e) {
                this.$toast.open({
                        message:'获取产品信息失败!',
                        type:'error',
                        position:'top'
                    });
            }
        },
        btnChange() {
            var file = document.getElementById('file');
            file.click();
        },
        fileChange(e) {
            const _this = this;
            try {
                let fileData = this.getFile();
                if(fileData == null) return;
                if(!this.beforeUpload(fileData)) return;
                //本地预览
                var reader = new FileReader();
                reader.readAsDataURL(fileData);                    
                reader.onload = function(e) {
                    var src = this.result;
                    _this.imgPath = src;
                }
            } catch (error) {
                console.debug('choice file err:',error);
            }
        },
        beforeUpload(f) {
            const maxSzie = glob.Config.UploadSize;
            if (f.size/1024/1024 > maxSzie) {
            this.$message.error('上传文件大小不能超过'+maxSzie+'M.');
            return false;
            }
            var types = glob.Config.UploadType;
            for (let i = 0; i < types.length; i++) {
                if(types[i]===f.type) return true;          
            }
            this.$dialog.alert({
                mes: '上传文件格式不允许!',
            });
            return false;
        },
        getFile() {
            var file = document.getElementById("file");
            if(file.files.length == 0) {
                console.log("没有选中文件");
                return null;
            }
            return file.files[0];
        },
        confirmSubmit() {
            this.saveProduct();
            console.log("保存");
        },
        cancel() {
            let _this = this;
            _this.isShow = false;
            _this.isEdit = false;
        },
        format_date(value){
            if (value) {
            return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },
        deleteProduct(item) {
            let _this = this;
            this.selectProduct = item;
            _this.isShowDelete = true;
        },
        async  deleteSubmit() {
            let res = await this.$api.request('DELETE', '/service/' + this.selectProduct.id);
            if(res.res=='err') {
                this.$toast.open({
                        message:'删除失败!',
                        type:'warning',
                        position:'top'
                        
                    });
            } else {
                this.$toast.open({
                    message:'删除成功!',
                    type:'success',
                    position:'top'
                    
                });
            }
            this.isShowDelete = false;
            this.requestData();
        },
        deleteCancel() {
            this.isShowDelete = false;
        }
    },
}
</script>
<style lang="scss" scoped>
    .fz-form-label{
        padding-right: 10px;
    }
    .form-control{
        width: 100%;
    }
    .d-content{
           padding: 5px 25px;
        background: #fff;
        border: 1px solid #E1E1E1;
        padding-top: 20px;
        margin-bottom: 20px;
        padding-bottom: 20px;
 
        .form-group{
            margin-bottom: 0px;
            margin-left: -20px;
        }
        .control-label{
            margin: 0;
            padding-top: 0
        }
        .col-xs-6{
            padding: 5px 0;
        }
        .form-control{
            background-color: #fff;
            width: 90%;
            margin-left: 5%;
        }
    }
</style>